import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Link } from 'react-router-dom';
import CreateNewEvent from '../components/CreateNewEvent';
import { Fragment } from 'react';
import PageHeader from '../components/molecules/PageHeader';
import { useEvents } from '../hooks/events.hook';

const Events = ({ mode = '' }) => {
  const { events } = useEvents();

  const addEventButton = () => {
    return (
      <Link
        to='/manage/events/create'
        style={{
          display: 'inherit',
          justifyContent: 'center',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <AddCircleOutlineIcon /> &nbsp; Create New Event
      </Link>
    );
  };

  if (mode === 'create') {
    return <CreateNewEvent />;
  } else {
    return (
      <div>
        <PageHeader RightSideComponent={addEventButton}>
          Event Management
        </PageHeader>

        <div className='grid grid-cols-5'>
          <div className='col-span-2 p-4 text-xl font-bold'>Event Name</div>
          <div className='p-4 text-xl font-bold'>Attendance</div>

          {events?.map(event => {
            return (
              <Fragment key={event.event_id}>
                <div className='col-span-2 col-start-1 px-4 py-2'>
                  <Link to={`/manage/events/${event.event_id}`}>
                    {event.event_title}
                  </Link>
                </div>
                <div className='px-4 py-2'>{event.attendees}</div>
              </Fragment>
            );
          })}
        </div>
      </div>
    );
  }
};

export default Events;
